import axios from 'axios';
import {backendHost} from '../../config';

export const getBalanceCorrection = (params) => {
    return axios.get(`${backendHost}/api/partners/admin/balance-correction`, {params});
};